import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ChipsInputComponent } from './chips-input.component';

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [ChipsInputComponent],
    exports: [ChipsInputComponent],
})
export class UiChipsInputModule {}

